// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3haCH","bigColWidth":"Table_bigColWidth__24xSc","biggerColWidth":"Table_biggerColWidth__1rj8O","row":"Table_row__2_Lmz","col":"Table_col__3sU2-"};